import { IContact } from '@epi-models/pages/CompanyInfo';
import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface ContactsState {
  contacts: IContact[];
  isLoading: boolean;
  isLoaded: boolean;
  isError?: boolean;
}

interface ContactsAction {
  type: string;
  contacts?: IContact[];
}

export const getInitialState = (): ContactsState => ({
  contacts: [],
  isLoading: false,
  isLoaded: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_CONTACTS}_REQUEST`]: (
    state: ContactsState
  ): Partial<ContactsState> => ({
    isLoading: true,
    isLoaded: false
  }),

  [`${ApiConstants.LOAD_CONTACTS}_SUCCESS`]: (
    state: ContactsState,
    { contacts }: ContactsAction
  ): Partial<ContactsState> => ({
    contacts,
    isLoading: false,
    isLoaded: true
  }),

  [`${ApiConstants.LOAD_CONTACTS}_FAILURE`]: (
    state: ContactsState
  ): Partial<ContactsState> => ({
    contacts: [],
    isLoading: false,
    isError: true
  }),

  [`${ApiConstants.LOGOUT_ACTION}_SUCCESS`]: (): ContactsState =>
    getInitialState()
});
